<template>
    <div>
        <div v-if="canEdit && !onlyConfirmed" class="flex justify-between items-center mb-4 gap-y-2 flex-wrap-reverse">
            <div class="w-full">
                <Tabs @update:selectedTab="onTabChange" :tabs="filters" :selectedTab="currentFilter"
                    :controlCurrentTab="true" :roundedTabs="true" :smallTabs="true" :uppercase="false" :shouldFit="true"
                    :avoidBreakingWords="true" />
            </div>
            <div class="flex gap-x-2 w-full items-center">
                <PrimaryButton v-if="invitesEnabled" @click="$emit('showInviteForm')" size="custom"
                    class="rounded-full gap-x-2 flex items-center py-[0.2rem] px-2">
                    <PhUserPlus class="size-5" />
                    <p class="text-sm" v-text="inviteText ?? $lang.get('Invite')" />
                </PrimaryButton>
                <!-- <PrimaryButton v-if="showApproveAllButton(currentFilter)" @click="approveAll" :disabled="inQueue" -->
                <!--     size="custom" class="rounded-full gap-x-2 flex items-center py-[0.2rem] px-2"> -->
                <!--     <PhSpinnerGap class="size-5" v-if="this.isApproving"> -->
                <!--         <animate attributeName="opacity" values="0;1;0" dur="4s" repeatCount="indefinite" /> -->
                <!--         <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="5s" -->
                <!--             from="0 0 0" to="360 0 0" repeatCount="indefinite" /> -->
                <!--     </PhSpinnerGap> -->
                <!--     <PhUserPlus class="size-5" v-if="!this.isApproving" /> -->
                <!--     <p v-if="!this.isApproving" class="text-sm" v-text="$lang.get('Approve all')" /> -->
                <!--     <p v-if="this.isApproving" class="text-sm" v-text="$lang.get('Approving members')" /> -->
                <!-- </PrimaryButton> -->
            </div>

        </div>
        <div>
            <Transition name="fade" mode="out-in">
                <table class="w-full" :key="currentFilter">

                    <tbody class="border-t border-border-light">
                        <tr v-for="item in currentPageItems" :key="item.id" class="border-b border-border-light w-full">
                            <td class="py-2.5 w-2/3">
                                <div class="flex items-center gap-x-2">
                                    <Link :href="$getModelUrl(item)">
                                    <ModelImage :src="item.imageSrc" :modelClass="item.modelClass"
                                        imageClasses="object-cover w-full h-full" :clickable="true" :class="[
                                            item.modelClass == 'user'
                                                ? 'rounded-full'
                                                : 'rounded',
                                            'size-7 aspect-square flex-shrink-0',
                                        ]" :fallbackBorder="`border border-${item.modelClass}-accent`" />
                                    </Link>
                                    <Link :href="$getModelUrl(item)" class="font-medium text-text/80 underline-hover"
                                        v-text="item.name" />
                                </div>
                            </td>

                            <td v-if="false">
                                <SecondaryButton size="xs" @click="sendMessage()">
                                    <PhChatCircleText class="size-6" />
                                </SecondaryButton>
                            </td>

                            <td v-if="canEdit">
                                <div class="size-full flex items-center justify-center"></div>
                            </td>

                            <td v-if="canEdit">
                                <div class="flex items-center justify-end gap-x-1.5">
                                    <p v-if="item.type == 'sent'" class="text-sm italic pr-3"
                                        v-text="this.$lang.get('Invite sent')" />

                                    <div v-else-if="item.type == 'approved'"
                                        class="p-1 rounded-full bg-success text-white w-fit self-center">
                                        <PhCheck class="size-3" weight="bold" />
                                    </div>
                                    <div class="relative" v-else-if="item.type == 'recieved'">
                                        <SecondaryButton @click="approveItem(item)" size="xs"
                                            class="flex-shrink-0 whitespace-nowrap"
                                            :disabled="actionsDisabled || inQueue" :filled="true"
                                            v-text="approveAffiliationText" />
                                        <Transition name="fade" mode="out-in">
                                            <div v-if="
                                                approvingPendingApprovalItemId ==
                                                item.pendingApprovalId
                                            " class="absolute w-full inset-0 h-full flex items-center justify-center">
                                                <PhCircleNotch class="h-3/5 animate-spin" />
                                            </div>
                                        </Transition>
                                    </div>

                                    <div class="relative">
                                        <PrimaryButton @click="() => removeItem(item)" size="xs"
                                            class="flex-shrink-0 whitespace-nowrap"
                                            :disabled="actionsDisabled || inQueue" v-text="item.type == 'recieved'
                                                ? $lang.get('Deny')
                                                : removeText
                                                " />
                                        <Transition name="fade" mode="out-in">
                                            <div v-if="
                                                (item.hasOwnProperty(
                                                    'pendingApprovalId'
                                                ) &&
                                                    denyingPendingApprovalItemId ==
                                                    item.pendingApprovalId) ||
                                                (item.hasOwnProperty(
                                                    'affiliation_id'
                                                ) &&
                                                    removingApprovedItemdId ==
                                                    item.affiliation_id)
                                            " class="absolute w-full inset-0 h-full flex items-center justify-center">
                                                <PhCircleNotch class="h-3/5 animate-spin" />
                                            </div>
                                        </Transition>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Transition>
            <Transition name="fade" mode="out-in">
                <p v-if="currentPageItems.length == 0" class="text-center italic pb-4" v-text="currentFilter == 'all'
                    ? $lang.get('Nothing to show')
                    : $lang.get('No :types to show', {
                        types: filterTabNames[
                            currentFilter
                        ].toLowerCase(),
                    })
                    " />
            </Transition>
            <Transition name="fade" mode="out-in">
                <Pagination v-if="currentPageItems.length > 0" @ChangePage="(page) => (currentPage = page)"
                    :currentPage="currentPage" :perPage="perPage" :rowsCount="filteredItems.length"
                    :totalCount="allItems.length" :lastPage="nbrPages" class="pt-4" :smallSize="true" />
            </Transition>
            <ConfirmDangerModal ref="confirmDanger" />
        </div>
    </div>
</template>

<script>
import ModelImage from '@/Components/ModelComponents/ModelImage.vue'
import Pagination from '@/Components/DataTable/Pagination.vue'
import ReactiveHeightTransition from '@/Components/Transitions/ReactiveHeightTransition.vue'
import { Link } from '@inertiajs/vue3'
import {
    PhSpinnerGap,
    PhChatCircleText,
    PhCircleNotch,
    PhCheck,
    PhUserPlus,
} from '@phosphor-icons/vue'
import SecondaryButton from '@/Components/Elements/SecondaryButton.vue'
import PrimaryButton from '@/Components/Elements/PrimaryButton.vue'
import ConfirmDangerModal from '@/Components/Modals/ConfirmDangerModal.vue'
import Tabs from '@/Components/Utilities/Tabs.vue'

export default {
    name: 'AffiliationTable',
    components: {
        ModelImage,
        Pagination,
        ReactiveHeightTransition,
        SecondaryButton,
        PrimaryButton,
        Link,
        ConfirmDangerModal,
        PhSpinnerGap,
        PhChatCircleText,
        PhCircleNotch,
        PhCheck,
        PhUserPlus,
        Tabs,
    },
    emits: ['reloadRelations', 'removeItem', 'showInviteForm'],

    expose: 'goToInvitationsTab',

    props: {
        parentModel: {
            type: Object,
            default: {}
        },
        filterTabNames: {
            type: Object,
            required: true,
        },
        items: {
            type: Array,
            required: true,
            validator: (value) => {
                return value.every(
                    (item) =>
                        item.hasOwnProperty('name') &&
                        item.hasOwnProperty('modelClass') &&
                        item.hasOwnProperty('first_image') &&
                        ((item.hasOwnProperty('pivot') &&
                            item.pivot.hasOwnProperty('id')) ||
                            item.hasOwnProperty('pivot_id'))
                )
            },
        },
        sentRequests: {
            type: Array,
            default: [],
            validator: (value) => {
                return value.every(
                    (item) =>
                        item.hasOwnProperty('id') &&
                        item.hasOwnProperty('target') &&
                        item.target.hasOwnProperty('name') &&
                        item.target.hasOwnProperty('modelClass') &&
                        item.target.hasOwnProperty('first_image')
                )
            },
        },
        recievedRequests: {
            type: Array,
            default: [],
            validator: (value) => {
                return value.every(
                    (item) =>
                        item.hasOwnProperty('id') &&
                        item.hasOwnProperty('initiator') &&
                        item.initiator.hasOwnProperty('name') &&
                        item.initiator.hasOwnProperty('modelClass') &&
                        item.initiator.hasOwnProperty('first_image')
                )
            },
        },
        canEdit: {
            type: Boolean,
            required: true,
        },
        onlyConfirmed: {
            type: Boolean,
            default: false,
        },
        invitesEnabled: {
            type: Boolean,
            default: false,
        },
        approveAffiliationText: {
            type: String,
            required: true,
        },
        definitiveItemName: {
            type: String,
            required: true,
        },
        definitiveRecievedName: {
            type: String,
            required: true,
        },
        definitiveSentName: {
            type: [String, null],
            default: null,
            validator: (value, props) => {
                if (props.invitesEnabled && value == null) {
                    return false
                }
                return true
            },
        },
        inviteText: {
            type: String,
            default: null,
        },
        removeButtonText: {
            type: String,
            default: null,
        },
        initialTab: {
            type: [String, null],
            default: null,
        },
        isManagingEmployees: {
            type: Boolean,
            default: false
        },
        isInQueue: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            currentFilter: 'all',
            currentPage: 1,
            perPage: 6,
            // Used to show when a sent or recieved request is being denied. Will show a spinner and disable other actions
            denyingPendingApprovalItemId: null,
            // Used to show when a sent or recieved request is being approved. Will show a spinner and disable other actions
            approvingPendingApprovalItemId: null,
            // Used to show when a approved item is being removed. Will show a spinner and disable other actions
            removingApprovedItemdId: null,
            isApproving: false,
            inQueue: this.isInQueue
        }
    },

    mounted() {
        if (
            this.initialTab != null &&
            this.filters.some((tab) => tab.id == this.initialTab)
        ) {
            this.currentFilter = this.initialTab
        }
    },

    computed: {
        filters() {
            let allItemsCount =
                this.items.length +
                this.sentRequests.length +
                this.recievedRequests.length

            let tabs = [
                {
                    id: 'all',
                    name: `${this.filterTabNames.all} (${allItemsCount})`,
                },
                {
                    id: 'approved',
                    name: `${this.filterTabNames.approved} (${this.items.length})`,
                },
            ]

            if (this.invitesEnabled) {
                tabs.push({
                    id: 'sentRequests',
                    name: `${this.filterTabNames.sentRequests} (${this.sentRequests.length})`,
                })
            }

            tabs.push({
                id: 'recievedRequests',
                name: `${this.filterTabNames.recievedRequests} (${this.recievedRequests.length})`,
            })

            return tabs
        },

        /**
         * Combines the approved items, the sent pending approvals and the recieved pending approvals
         * into one array.
         */
        allItems() {
            let allItems = this.approvedItems

            if (this.canEdit) {
                allItems = allItems.concat(this.sent).concat(this.recieved)
            }

            return allItems.sort((a, b) => {
                return a.name.localeCompare(b.name)
            })
        },

        /**
         * Returns an array of users that are affiliated to the model this panel/modal is show on.
         */
        approvedItems() {
            return this.items
                .map((item) => ({
                    ...item,
                    affiliation_id: item.pivot_id || item.pivot.id,
                    imageSrc: item.first_image?.preview_url || null,
                    type: 'approved',
                }))
                .sort((a, b) => {
                    return a.name.localeCompare(b.name)
                })
        },

        /**
         * Returns an array of users that each belongs to a pending approval.
         * The user is the one to approve the affiliation.
         */
        sent() {
            return this.sentRequests
                .map((item) => ({
                    ...item.target,
                    pendingApprovalId: item.id,
                    imageSrc: item.target.first_image?.preview_url || null,
                    type: 'sent',
                }))
                .sort((a, b) => {
                    return a.name.localeCompare(b.name)
                })
        },

        /**
         * Returns an array of users that each belongs to a pending approval.
         * The organization is the one to approve the affiliation.
         */
        recieved() {
            return this.recievedRequests
                .map((item) => ({
                    ...item.initiator,
                    imageSrc: item.initiator.first_image?.preview_url || null,
                    type: 'recieved',
                    pendingApprovalId: item.id,
                }))
                .sort((a, b) => {
                    return a.name.localeCompare(b.name)
                })
        },

        currentPageItems() {
            return this.filteredItems.slice(
                this.perPage * (this.currentPage - 1),
                this.perPage * this.currentPage
            )
        },

        nbrPages() {
            return Math.ceil(this.filteredItems.length / this.perPage)
        },

        filteredItems() {
            switch (this.currentFilter) {
                case 'all':
                    return this.allItems
                case 'approved':
                    return this.approvedItems
                case 'sentRequests':
                    return this.sent
                case 'recievedRequests':
                    return this.recieved
            }
        },

        actionsDisabled() {
            return (
                this.removingApprovedItemdId != null ||
                this.denyingPendingApprovalItemId != null ||
                this.approvingPendingApprovalItemId != null
            )
        },

        removeText() {
            if (this.removeButtonText) {
                return this.removeButtonText
            }
            return this.$lang.get('Remove')
        },
    },

    watch: {
        /**
         * When the items length has changed, then we assume that was because of a removal of a approved item.
         * So we reset the removingApprovedItemdId to null
         */
        'items.length'() {
            this.removingApprovedItemdId = null
        },

        /**
         * When the sent requests length has changed, then we assume that was because a either a approval or a denial of a pending approval.
         * Therefore we reset them both null. They can not be active at the same time so tehre is not danger resetting them at the same time
         */
        'recievedRequests.length'() {
            this.denyingPendingApprovalItemId = null
            this.approvingPendingApprovalItemId = null
        },

        /**
         * When the recieved requests length has changed, then we assume that was because  an invitation was rescinded.
         * Therefore we reset the denyingPendingApprovalItemId to null
         */
        'sentRequests.length'() {
            this.denyingPendingApprovalItemId = null
        },
    },

    methods: {
        showApproveAllButton(currentFilter) {
            return (this.canEdit && currentFilter === 'recievedRequests' && !this.isInQueue && this.recievedRequests.length > 0)
        },
        approveItem(item) {
            if (
                item.pendingApprovalId &&
                item.type == 'recieved' &&
                !this.actionsDisabled
            ) {
                this.approvingPendingApprovalItemId = item.pendingApprovalId
                axios
                    .post(
                        route(
                            'api.pending-approvals.approve',
                            item.pendingApprovalId
                        )
                    )
                    .then((response) => {
                        this.$emit('reloadRelations')
                        this.goToApprovedTab()
                    })
            }
        },

        removeItem(item) {
            if (item.type == 'approved') {
                // Remove approved items
                this.$refs.confirmDanger
                    .confirm({
                        title: this.$lang.get('Delete :definitive_item_name', {
                            definitive_item_name: this.definitiveItemName,
                        }),
                        body: this.$lang.get(
                            'Are you sure you want to delete :definitive_item_name?',
                            {
                                definitive_item_name: this.definitiveItemName,
                            }
                        ),
                    })
                    .then((confirmed) => {
                        if (confirmed) {
                            this.removeApprovedItem(item)
                        }
                    })
            } else {
                // Remove pending approvals
                this.$refs.confirmDanger
                    .confirm({
                        title: this.$lang.get('Delete :definitive_item_name', {
                            definitive_item_name:
                                item.type == 'recieved'
                                    ? this.definitiveRecievedName
                                    : this.definitiveSentName,
                        }),
                        body: this.$lang.get(
                            'Are you sure you want to delete :definitive_item_name?',
                            {
                                definitive_item_name:
                                    item.type == 'recieved'
                                        ? this.definitiveRecievedName
                                        : this.definitiveSentName,
                            }
                        ),
                    })
                    .then((confirmed) => {
                        if (confirmed) {
                            this.removePendingApproval(item)
                        }
                    })
            }
        },

        removeApprovedItem(item) {
            this.removingApprovedItemdId = item.affiliation_id
            this.$emit('removeItem', item.affiliation_id)
        },

        removePendingApproval(item) {
            if (item.pendingApprovalId && !this.actionsDisabled) {
                this.denyingPendingApprovalItemId = item.pendingApprovalId
                axios
                    .delete(
                        route(
                            'api.pending-approvals.destroy',
                            item.pendingApprovalId
                        )
                    )
                    .then((response) => {
                        this.$emit('reloadRelations')
                    })
            }
        },
        approveAll() {
            this.$refs.confirmDanger
                .confirm({
                    title: this.$lang.get('Approve all employee requests?'),
                    body: this.$lang.get(
                        'Are you sure you want to approve all employee requests? Depending on the amount of requests this can take some time. You will get a notification when the job is done.',
                    ),
                    confirmText: this.$lang.get('Approve all')
                })
                .then(confirmed => {
                    if (confirmed) {
                        this.isApproving = true
                        this.inQueue = true
                        axios.post(
                            route(
                                'api.pending-approvals.approve-all',
                                this.parentModel.id
                            )
                        ).then(response => {
                            // this.isApproving = false
                            this.$emit('reloadRelations')
                        })
                    }
                }
                )
        },
        sendMessage() {
            /**
             * TODO, redirect to the targets show page with message modal popping up.
             */
        },

        goToInvitationsTab() {
            this.currentFilter = 'sentRequests'
        },

        goToApprovedTab() {
            this.currentFilter = 'approved'
        },

        onTabChange(tab) {
            this.currentFilter = tab
            this.currentPage = 1
        },
    },
}
</script>
